let backendHost;

const hostname = window && window.location && window.location.hostname;

if (hostname === 'localhost') {
    backendHost = 'http://localhost:9090';
} else if (hostname === 'umbrel-dev' || hostname === 'staff.umbrel.thewebpeople.ca') {
    backendHost = 'https://staff.tobermorybrewingco.com';
} else {
    backendHost = 'https://staff.tobermorybrewingco.com';
}

export const API_ROOT = `${backendHost}/api`;